export default {"src":"/_next/static/media/telegram.2b292bd3.svg","height":240,"width":240};